import React from 'react'
import { mount, shallow } from 'enzyme'
import Form1040 from '../forms/Form1040'

describe('<Form1040 />', () => {
  const noop = () => {}
  const formData = [
    {
      firstName: 'John',
      lastName: 'Doe',
      tin: '234-22-4813',
      address: '238 8th Street',
      apt: 482,
      city: 'San Francisco',
      state: 'CA',
      zip: '47239',
      valid: true
    },
    {
      // Test secondTin being blank with presence of secondName
      firstName: 'Jack',
      lastName: 'Smith',
      secondFirstName: 'Jane',
      secondLastName: 'Smith',
      tin: '442-33-9034',
      secondTin: '',
      address: '5323 Oak Ridge Road',
      apt: 444,
      city: 'Chicago',
      state: 'IL',
      zip: '09637',
      valid: false
    },
    {
      // Test secondName being blank with presence of secondTin
      firstName: 'Jack',
      lastName: 'Smith',
      secondName: '',
      tin: '442-33-9034',
      secondTin: '442-90-3324',
      address: '5323 Oak Ridge Road',
      apt: 444,
      city: 'Chicago',
      state: 'IL',
      zip: '09637',
      valid: false
    },
    {
      firstName: 'asdf',
      lastName: '',
      tin: '234-47-4826',
      address: '424 99th Ave',
      apt: 1,
      city: 'St. Louis',
      state: 'MO',
      zip: '22342',
      valid: false
    },
    {
      firstName: 'John C.',
      lastName: 'Riley',
      tin: '134',
      address: 'this is an address',
      apt: 4,
      city: 'Dallas',
      state: 'TX',
      zip: '29445',
      valid: false
    }
  ]

  it('should render without crashing', () => {
    mount(<Form1040 defaults={{}} onDataChange={noop} year={2018} />)
  })
  it('should call its onDataChange prop any time a field is modified', () => {
    const onDataChangeMock = jest.fn()
    const wrapper = mount(
      <Form1040 defaults={{}} onDataChange={onDataChangeMock} year={2018} />
    )
    const inputs = wrapper.find('input')
    inputs.forEach(input => {
      input.simulate('change')
    })
    expect(onDataChangeMock.mock.calls.length).toEqual(inputs.length + 1) // +1 is for the initial call at the componentDid mount
  })
  it('should correctly validate data from Form 1040', () => {
    const wrapper = shallow(
      <Form1040 defaults={{}} onDataChange={() => {}} year={2018} />
    )
    const instance = wrapper.instance()
    for (const data of formData) {
      const testData = { ...data }
      // This step is necessary to prevent the validator from validating the 'valid' field
      delete testData.valid
      expect(instance.validate(testData)).toEqual(data.valid)
    }
  })
})